<div class="myBackground">
  <p style="margin:auto;position:absolute;top:20%;left:0;right:0;color:white;text-align:center;">
  
    <font size="48">
      <b>
        Forms Portal
      </b>
    </font> 
    <br><br>
    <b>Please add to home screen...</b>
  </p>
  
  
    <div *ngIf="globals.isiOS"><br><br><br>
      <p style="margin:auto;position:absolute;bottom:26%;left:0;right:0;color:white;text-align:center;">
        <br>
        1. Tap the <img src="assets/images/install1.png" alt="install instructions" style="max-height:60px;"/> icon in Safari's menu bar
        <br>
        2. Then, tap the <img src="assets/images/install2.png" alt="install instructions" style="max-height:100px;"/> icon
      </p>
    </div>
  
  
  <a style="position:absolute;bottom:5%;left:0;right:0;text-align:center;" (click)="overrideInstall()" >
    <button kendoButton [look]="'outline'" style="border-color:white;color:white;">Continue without install</button>
  </a>
  
  
  <p style="margin:auto;position:absolute;bottom:1%;left:0;right:0;color:darkblue;text-align:center;font-size:0.5em;">installed:{{globals.isInstalled}}|iOS:{{globals.isiOS}}|{{globals.device}}|overrideInstall:{{globals.overrideInstallRequirement}}</p>  
</div>